import { createNextWizard } from "@krakentech/blueprint-onboarding/next-wizard/pages-router"
import { apiRoutesPaths } from "@/routes/api"
import { type OnboardingRouteNames } from "@/routes/onboarding"
import { ONBOARDING_DEFAULT_STATE } from "../constants/onboardingDefaultState"
import { deserializeState, serializeState } from "../serializers/serializers"
import { type OnboardingSerializedState, type OnboardingState } from "../types/onboardingState"
import { getOnboardingSteps } from "./getOnboardingSteps"

export const onboardingWizard = createNextWizard<
    typeof OnboardingRouteNames,
    OnboardingState,
    OnboardingSerializedState
>({
    cookieName: "onboarding-spj-journey",
    encryptionSecret: process.env.COOKIE_ENCRYPTION_SECRET,
    cookieApiHandlerRoute: apiRoutesPaths.submitForm.resolve(),
    initialState: ONBOARDING_DEFAULT_STATE,
    steps: getOnboardingSteps,
    serializeState,
    deserializeState,
})
